import { render, staticRenderFns } from "./BrowseBuildingSeko.vue?vue&type=template&id=19352b3a&scoped=true&"
import script from "./BrowseBuildingSeko.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingSeko.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingSeko.vue?vue&type=style&index=0&id=19352b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19352b3a",
  null
  
)

export default component.exports